export default __webpack_public_path__ + "static/media/LufgaRegular.4f0d570c.ttf";